import { getAndProcessUsers, User } from "./Users";
import { getAndProcessGroups, Group } from "./Groups";
import { SchemaClient } from "../../../common/GraphqlClient";


export const getAndProcessReviewers = async (
  client: SchemaClient,
  userId: string,
  group: string
): Promise<User[]> => {
  if (!userId || !group) {
    return [];
  }

  const subgroups = group.split("").reduce((subgroups: string[], character: string) => {
    subgroups.unshift((subgroups?.[0] ?? "") + character);
    return subgroups;
  }, []);

  const [
    users,
    ...groups
  ] = await Promise.all([
    getAndProcessUsers(client),
    ...subgroups.map(
      (subgroup: string) => getAndProcessGroups(client, subgroup)
    )
  ]);

  const reviewerIds = Array.from(
    new Set(
      groups
        .flatMap((groups: Group[]) => groups)
        .filter((group: Group) => group.reviewers)
        .flatMap((group: Group) => group.reviewers!)
        .map((reviewer: User) => reviewer.userId)
    )
  );

  return users.filter((user: User) => {
    return user?.userId !== userId && reviewerIds.includes(user?.userId)
  });
};